export var Filters = {
  make: 'make',
  year: 'year',
  bodyType: 'body_type',
  price: 'price',
  emi: 'emi',
  price_emi: 'price_emi'
};